import { PhieuKiemTraPassKhanComponent } from "./../phieu-kiem-tra-pass-khan/phieu-kiem-tra-pass-khan.component";
import { DungChungService } from "./../../../dung-chung/__services/dung-chung.service";
// Angular
import {
	Component,
	OnInit,
	ChangeDetectionStrategy,
	OnDestroy,
	ChangeDetectorRef,
	Inject,
	ViewChildren,
	ViewRef,
	ElementRef,
	ViewChild,
	HostListener,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
// Material
import {
	MatPaginator,
	MatSort,
	MatDialog,
	MatTableDataSource,
	MAT_DIALOG_DATA,
	MatDialogRef,
} from "@angular/material";
import { SelectionModel } from "@angular/cdk/collections";
import {
	CdkDragStart,
	CdkDropList,
	moveItemInArray,
} from "@angular/cdk/drag-drop";
import { CdkVirtualScrollViewport } from "@angular/cdk/scrolling";
// RxJS
import { Observable, BehaviorSubject, Subscription, ReplaySubject } from "rxjs";
import { map, startWith } from "rxjs/operators";
// NGRX
// Service
import { SubheaderService } from "app/core/_base/layout";
import { LayoutUtilsService, MessageType } from "app/core/_base/crud";
import { YeuCauXuatKhanService } from "../yeu-cau-xuat-khan-service/yeu-cau-xuat-khan.service";
//Models
import {
	YeuCauXuatKhanModel,
	SettingYCXK,
} from "../yeu-cau-xuat-khan-model/yeu-cau-xuat-khan.model";
import { YeuCauXuatKhan_CtModel } from "../yeu-cau-xuat-khan-model/yeu-cau-xuat-khan.model";
import moment from "moment";
import { CommonConFig } from "app/views/pages/nfc/dung-chung/__model/common_config.model";
import { TokenStorage } from "../../../../../../core/auth/_services";
import { isNumber } from "util";
import { FunctionPublic } from "../../../dung-chung/__function/common_function";
import { PhieuKiemTraService } from "../../../qa-qc/kiem-tra-hang-hoa/phieu-kiem-tra/phieu-kiem-tra-service/phieu-kiem-tra.service";
import { HangNhapKho } from "../../../qa-qc/kiem-tra-hang-hoa/danh-sach-hang-ton-kho/danh-sach-hang-ton-kho-model/danh-sach-hang-ton-kho.model";
import { KhoDeNghiXuatKhoDialogDetailComponent } from "../../../chuc-nang-kho-page/kho-de-nghi-xuat-kho-page/kho-de-nghi-xuat-kho-dialog-detail/kho-de-nghi-xuat-kho-dialog-detail.component";
import { KhoDeNghiXuatKhoService } from "../../../chuc-nang-kho/kho-de-nghi-xuat-kho/kho-de-nghi-xuat-kho-service/kho-de-nghi-xuat-kho.service";
@Component({
	selector: "kt-yeu-cau-xuat-khan-edit-dialog",
	templateUrl: "./yeu-cau-xuat-khan-edit-dialog.component.html",
	styleUrls: ["../yeu-cau-xuat-khan.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class YeuCauXuatKhanEditDialogComponent implements OnInit, OnDestroy {
	//#region Variables
	/*Config Form */
	CONFIG: CommonConFig;
	/* Comment columns mat-table
		Các trường columns cho bảng:
		- displayedColumns: display ra form
		- availableColumns: các cột sẽ được add vào display.
	*/
	displayedColumns = [];
	availableColumns = [
		{
			stt: 1,
			name: "STT",
			displayName: "STT",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 3,
			name: "HangHoaLot",
			displayName: "Hàng hóa / Lot",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 4,
			name: "Kho",
			displayName: "Kho",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 5,
			name: "NgaySX",
			displayName: "Ngày sản xuất",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 5,
			name: "NgayDeNghiXuat",
			displayName: "Ngày đề nghị xuất",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 7,
			name: "NgayNhan",
			displayName: "Ngày nhận",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 7,
			name: "SoLuongCanXuat",
			displayName: "Số lượng cần xuất",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 7,
			name: "NguyenNhanXK",
			displayName: "Nguyên nhân xuất khẩn",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 7,
			name: "GhiChu",
			displayName: "Ghi chú",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 99,
			name: "actions",
			displayName: "Thao tác",
			alwaysChecked: true,
			isShow: true,
		},
	];
	columnExtend = [
		{
			stt: 11,
			name: "SoPhieuKiemTra",
			displayName: "Số phiếu kiểm tra",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 8,
			name: "NgayKiemTra",
			displayName: "Ngày kiểm tra",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 9,
			name: "NguoiKiemTra",
			displayName: "Người kiểm tra",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 10,
			name: "KetQua",
			displayName: "Kết quả",
			alwaysChecked: false,
			isShow: true,
		},
	];
	/* Các trường focus cho các tag trong form */
	@ViewChildren("focus") focus;
	@ViewChild(CdkVirtualScrollViewport, {
		static: false,
	})
	cdkVirtualScrollViewPort: CdkVirtualScrollViewport;
	// Master
	YeuCauXuatKhan: YeuCauXuatKhanModel;
	YeuCauXuatKhanForm: FormGroup;
	hasFormErrors: boolean = false;
	// Detail
	YeuCauXuatKhan_Ct: YeuCauXuatKhan_CtModel;
	YeuCauXuatKhan_CtForm: FormGroup;
	hasSubFormErrors: boolean = false;
	// Selection
	selectedColumns = new SelectionModel<any>(true, this.availableColumns);
	selection = new SelectionModel<YeuCauXuatKhan_CtModel>(true, []);
	/* Loading.... */
	loadingSubject = new BehaviorSubject<boolean>(true);
	loading$: Observable<boolean>;
	// Public properties
	disBtnSubmit: boolean = false;
	isZoomSize: boolean = false;
	selectLoaiXuatKhan: string = "0";
	selectTinhTrangXuatKhan: string = "0";
	listHangHoa_id: any[] = [];
	selectHangHoa_id: string = "";
	filteredHangHoa_ids: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	ListHangHoa_idFilterCtrl: string = "";
	selectNguyenNhanXK: string[] = [];
	/* Danh sách chi tiết và tạm  */
	listYeuCauXuatKhan_Ct: any[] = [];
	tmpYeuCauXuatKhan_Ct: any[] = [];
	tmpYeuCauXuatKhan_CtInit: any[] = [];
	/* Extend field:  */
	title: string = ""; // Tiêu đề dialog
	previousIndex: number; // Lưu lại vị trí trước đó khi swap các cột trên lưới
	fixedPoint = 0; // Số chữ số phần thập phân cho kiểu dữ liệu số.
	isChange: boolean = false; // Trường kiểm tra dialog có cập nhập - thay đổi dữ liệu hay không
	saveAddedDNMH: number[] = []; // Save ID các record đã thay đổi để đánh dấu highlight trên list khi đóng dialog
	viewLoading: boolean = false; // Loading khi mở dialog
	canEdit: boolean = true; // Dialog có thể chỉnh sửa không?
	sumTT: number = 0; // Trường lưu tổng tiền
	disableNewButton: boolean = true; // Tắt nút thêm mới hàng khi chưa nhập đủ
	flagButtonAdd: boolean = true; // Cờ để ẩn hiện nút lưu và thêm mới
	category_path: string = "YCXK"; // path lấy tình trạng phím
	hanMucPB: string = "0";
	private componentSubscriptions: Subscription;
	waittingAddDetail: boolean = false;
	listNhomHang: any[] = [];
	selectNhomHang: string = "";
	filteredNhomHang: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	NhomHangFilterCtrl: string = "";
	haveElementNhomHang: boolean = false;
	listListBP: any[] = [];
	selectListBP: string = "";
	filteredListBP: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	ListBPFilterCtrl: string = "";
	haveElementListBP: boolean = false;
	listIdNV: any[] = [];
	selectIdNV: string = "";
	filteredIdNV: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	IdNVFilterCtrl: string = "";
	haveElementIdNV: boolean = false;
	listId_HH: any[] = [];
	selectId_HH: string = "";
	filteredId_HH: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	sumRecord = 0;
	Id_HHFilterCtrl: string = "";
	haveElementId_HH: boolean = false;
	listLotSX: any[] = [];
	selectLotSX: string = "";
	filteredLotSX: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	sumRecordLotSX = 0;
	LotSXFilterCtrl: string = "";
	haveElementLotSX: boolean = false;
	spinnerLoadHH: boolean = false;
	spinnerLoadLot: boolean = false;
	YeuCauXuatKhanFormInit: FormGroup;
	TAO = "1310";
	LIST_ROLES_USER: [] = [];
	SHOW_BUTTON_CREATE = new BehaviorSubject<boolean>(false);
	optionsTrangThai = SettingYCXK.pk_status;
	url_current = "them-moi";
	opendialog = false;
	IsKeHoach = true;
	//#endregion
	listTypeOfMers = SettingYCXK.type_of_mer;
	typeOfMer = this.listTypeOfMers[0].value;
	merOption = {};
	weightMer = 0;
	selectedOption = {};
	addMer = new BehaviorSubject<boolean>(false);
	btnTPKH = SettingYCXK.BTN_STPKH;
	actionCheck = new BehaviorSubject<boolean>(false);
	@HostListener("window:keyup", ["$event"])
	keyEvent(event: KeyboardEvent) {
		if (
			event.keyCode == this.CONFIG.BUTTON_FORM.BACK.KeyCombine.keycode &&
			!this.opendialog
		) {
			this.back(true);
		}
		if (
			event.altKey &&
			event.keyCode == this.CONFIG.BUTTON_FORM.SAVE.KeyCombine.keycode &&
			this.isAddUpdate() &&
			!this.opendialog
		) {
			this.onSubmit(1);
		}
		if (
			event.altKey &&
			event.keyCode ==
				this.CONFIG.BUTTON_FORM.SAVE_AND_NEW.KeyCombine.keycode &&
			this.isAddUpdate() &&
			!this.opendialog
		) {
			this.onSubmit(2);
		}
		if (
			event.altKey &&
			event.keyCode ==
				this.CONFIG.BUTTON_FORM.SAVE_TMP.KeyCombine.keycode &&
			this.isAddUpdate() &&
			!this.opendialog
		) {
			this.onSubmit(0);
		}
		if (
			event.altKey &&
			event.keyCode ==
				this.CONFIG.BUTTON_FORM.NOT_CONFIRM.KeyCombine.keycode &&
			this.YeuCauXuatKhan &&
			this.YeuCauXuatKhan.CoQuyenDuyet &&
			!this.opendialog
		) {
			if (
				this.url_current == "duyet" &&
				this.YeuCauXuatKhan.TinhTrang_Code ==
					this.optionsTrangThai[1].value
			)
				this.LuuKQDuyet(1);
			if (
				this.url_current == "duyet" &&
				this.YeuCauXuatKhan.TinhTrang_Code ==
					this.optionsTrangThai[2].value
			)
				this.LuuKQDuyet(2);
			if (
				this.url_current == "duyet" &&
				this.YeuCauXuatKhan.TinhTrang_Code ==
					this.optionsTrangThai[3].value
			)
				this.LuuKQDuyet(3);
		}
	}
	//#endregion
	/* ------------------------------------------------------------------ */
	constructor(
		public dialogRef: MatDialogRef<YeuCauXuatKhanEditDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private YeuCauXuatKhanFB: FormBuilder,
		private YeuCauXuatKhan_CtFB: FormBuilder,
		public dialog: MatDialog,
		private layoutUtilsService: LayoutUtilsService,
		private changeDetectorRefs: ChangeDetectorRef,
		private DungChungService: DungChungService,
		private tokenStorage: TokenStorage,
		private el: ElementRef,
		private servicePage: YeuCauXuatKhanService,
		private route: ActivatedRoute,
		private router: Router,
		private subheaderService: SubheaderService,
		private servicePKT: PhieuKiemTraService,
		private dkService: KhoDeNghiXuatKhoService
	) {
		this.router.routeReuseStrategy.shouldReuseRoute = () => false;
		let user = JSON.parse(localStorage.getItem("UserInfo"));
		this.LIST_ROLES_USER = user.roles;
		this.dialogRef.disableClose = true;
	}
	ngOnInit() {
		this.SHOW_BUTTON_CREATE.next(this.isTrueButton(this.TAO));
		this.viewLoading = true;
		this.CONFIG = new CommonConFig();
		this.YeuCauXuatKhan = new YeuCauXuatKhanModel();
		this.YeuCauXuatKhan.clear();
		this.YeuCauXuatKhan_Ct = new YeuCauXuatKhan_CtModel();
		this.YeuCauXuatKhan_Ct.clear();
		this.title = this.getTitle();
		//this.ListNhomHH();
		this.ListBP();
		this.createForm();
		this.ListId_HH();
		//#region Router Params Binding data
		//#endregion
		this.YeuCauXuatKhanFormInit = this.YeuCauXuatKhanForm.value;
		this.showColumnsInTable();
		this.applySelectedColumns();

		if(this.data.id){
			var id = this.data.id;
			this.servicePage.detail_pk_btp(id).subscribe(res => {
				if (res && res.status == 1) {
					this.YeuCauXuatKhan = res.data;
					if (this.YeuCauXuatKhanForm != null) {
						this.YeuCauXuatKhan.Id = id;
						let controls = this.YeuCauXuatKhanForm.controls;
						if (!this.isAddUpdate()) {
							this.YeuCauXuatKhanForm.disable();
							if (this.url_current == 'duyet' && this.YeuCauXuatKhan.TinhTrang_Code == this.optionsTrangThai[2].value) {
								this.YeuCauXuatKhanForm.controls['ketQuaKiemTraChatLuong'].enable();
								this.YeuCauXuatKhanForm.controls['yKienDeNghi'].enable();
							}
						}
						controls['soPhieu'].setValue(this.YeuCauXuatKhan.SoPhieu);
						controls['thoiGianTao'].setValue(this.YeuCauXuatKhan.ThoiGianTao);
						controls['nguoiTao'].setValue(this.YeuCauXuatKhan.TenNguoiTao);
						controls['tinhTrangXuatKhan'].setValue(this.YeuCauXuatKhan.TinhTrang);
						controls['nguoiDeNghi'].setValue(this.YeuCauXuatKhan.TenNguoiDeNghi);
						controls['ngayDeNghi'].setValue(this.YeuCauXuatKhan.NgayDeNghi);
						controls['ghiChuTinhTrang'].setValue(this.YeuCauXuatKhan.GhiChuLyDo);
						controls['tinhTrangHangDNXK'].setValue(Number(this.YeuCauXuatKhan.TinhTrangHangDNXK));
						controls['boPhanYeuCau'].setValue(Number(this.YeuCauXuatKhan.BoPhanYeuCauId));
						controls['ketQuaKiemTraChatLuong'].setValue(this.YeuCauXuatKhan.KetQuaKiemTraChatLuong);
						controls['yKienDeNghi'].setValue(this.YeuCauXuatKhan.YKien);
						if (this.isAddUpdate()) {
							this.GetDSNhanVien(this.YeuCauXuatKhan.BoPhanYeuCauId);
							controls['nguoiDeNghi'].setValue('' + this.YeuCauXuatKhan.NguoiDeNghi);
						}
						this.YeuCauXuatKhan.Cts.forEach((d, index) => {
							var data = {...d}; 
							data.KhoiLuongTon = Number(d.KhoiLuong);
							data.KhoiLuong = Number(d.KhoiLuong);
							this.tmpYeuCauXuatKhan_Ct.push(data);
							if (!data.IsMain) {
								d.machines.forEach(machine => {
									var data2 = {...d}; 
									data2.ma_may = machine.ma_may;
									data2.khoi_luong = machine.khoi_luong;

									this.tmpYeuCauXuatKhan_Ct.push(data2);
									var data3 = {...d}; 
									if (machine.chi_tieu.length > 0) {
										data3.chi_tieu = machine.chi_tieu
										this.tmpYeuCauXuatKhan_Ct.push(data3);
									}
								});
							}
						});
						this.tmpYeuCauXuatKhan_Ct = [...this.tmpYeuCauXuatKhan_Ct];
						this.tmpYeuCauXuatKhan_CtInit = [...this.tmpYeuCauXuatKhan_Ct];
						var tenNguoiLap = '';
						this.tokenStorage.getFullName().subscribe(t => {
							tenNguoiLap = t;
						});
						this.YeuCauXuatKhanFormInit = this.YeuCauXuatKhanForm.value;
						this.PushRowMainInList(this.tmpYeuCauXuatKhan_Ct);
						this.tmpYeuCauXuatKhan_Ct = [...this.tmpYeuCauXuatKhan_Ct];
						this.changeDetectorRefs.detectChanges();
					}
				}
			})
		}else{
			this.actionCheck.next(this.data.actionCheck);
			if (!this.SHOW_BUTTON_CREATE) this.router.navigateByUrl("/404");
			var tenNguoiLap = "";
			this.tokenStorage.getFullName().subscribe((t) => {
				tenNguoiLap = t;
			});
			var idNguoiLap = "";
			this.tokenStorage.getIDUser().subscribe((t) => {
				idNguoiLap = t;
			});
			var phongban = "";
			this.tokenStorage.getCoCauId().subscribe((t) => {
				phongban = t;
			});
			this.createBillNumber().then((r) => {
				this.YeuCauXuatKhanForm.controls["soPhieu"].setValue(r);
			});
			this.YeuCauXuatKhanForm.controls["tinhTrangXuatKhan"].setValue(
				this.optionsTrangThai[0].name
			);
			this.YeuCauXuatKhanForm.controls["boPhanYeuCau"].setValue(
				Number(phongban)
			);
			this.GetDSNhanVien(Number(phongban));
			this.YeuCauXuatKhanForm.controls["nguoiDeNghi"].setValue(
				"" + idNguoiLap
			);
			this.servicePage.FindDataLotDNXK(this.data.data).subscribe((res) => {
				if (res && res.status == 1) {
					let isAction = this.data.actionCheck;
					let selectList = this.data.selected;
					res.data.forEach((d,index) => {
						var boxs = [];
						var addLOT = true;
						if(!isAction && !d.IsMain){
							var lots = selectList.find(_x => _x.IdLo == d.IdLo);
							if(lots == null || (lots["MTs"].length == 0)) addLOT = false;
							else boxs = lots["MTs"];
						}
						if(addLOT){
							var data = {...d}; 
							data.IsChecked = true;
							data.KhoiLuong = Number(d.KhoiLuong);
							data.KhoiLuongTon = Number(d.KhoiLuong);
							this.tmpYeuCauXuatKhan_Ct.push(data);
							if (!data.IsMain) {
								d.machines.forEach(machine => {
									var addMT = true;
									if(boxs.length > 0){
										var mt = boxs.find(_x => _x == machine.id);
										if(mt == null) addMT = false;
									}
									if(addMT){
										var data2 = {...d}; 
										data2.IsChecked = true;
										data2.ma_may = machine.ma_may;
										data2.khoi_luong = machine.khoi_luong;
										this.tmpYeuCauXuatKhan_Ct.push(data2);
										var data3 = {...d}; 
										if (machine.chi_tieu.length > 0) {
											data3.chi_tieu = machine.chi_tieu
											this.tmpYeuCauXuatKhan_Ct.push(data3);
										}
									}
								});
							}
						}
					});
					this.tmpYeuCauXuatKhan_Ct = [...this.tmpYeuCauXuatKhan_Ct];
					this.changeDetectorRefs.detectChanges();
				} else {
					this.layoutUtilsService.showErorr("Không thể lấy được danh sách yêu cầu pass khẩn");
				}
			});
			this.changeDetectorRefs.detectChanges();
		}
	}
	ngOnDestroy() {
		if (this.componentSubscriptions) {
			this.componentSubscriptions.unsubscribe();
		}
	}
	isAddUpdate() {
		return !this.data.id;
	}
	isAccept() {
		return this.data.id;
	}
	isTrueButton(ROLENUMBER: string) {
		if (this.LIST_ROLES_USER.findIndex((x) => x == ROLENUMBER) > -1) {
			return true;
		}
		return false;
	}
	isCreate() {
		var idUser = "";
		this.tokenStorage.getIDUser().subscribe((t) => {
			idUser = t;
		});
		if (this.YeuCauXuatKhan.NguoiTao == +idUser) {
			return true;
		}
		return false;
	}
	createForm() {
		var tenNguoiLap = "";
		this.tokenStorage.getFullName().subscribe((t) => {
			tenNguoiLap = t;
		});
		this.YeuCauXuatKhanForm = this.YeuCauXuatKhanFB.group({
			// loaiXuatKhan: [this.YeuCauXuatKhan.LoaiPassKhan == 0 ?  '' : this.YeuCauXuatKhan.LoaiPassKhan, Validators.required],
			boPhanYeuCau: [
				this.YeuCauXuatKhan.BoPhanYeuCauId == null ||
				this.YeuCauXuatKhan.BoPhanYeuCauId == 0
					? ""
					: this.YeuCauXuatKhan.BoPhanYeuCauId + "",
				Validators.required,
			],
			soPhieu: [
				this.YeuCauXuatKhan.SoPhieu == null
					? ""
					: this.YeuCauXuatKhan.SoPhieu,
				Validators.required,
			],
			tinhTrangXuatKhan: [
				this.YeuCauXuatKhan.TinhTrang == null
					? ""
					: this.YeuCauXuatKhan.TinhTrang,
			],
			ghiChuTinhTrang: [""],
			ngayDeNghi: [
				this.YeuCauXuatKhan.NgayDeNghi
					? this.YeuCauXuatKhan.NgayDeNghi
					: new Date(),
				Validators.required,
			],
			nguoiDeNghi: [
				this.YeuCauXuatKhan.NguoiDeNghi == null
					? ""
					: this.YeuCauXuatKhan.NguoiDeNghi,
				[Validators.required, Validators.maxLength(50)],
			],
			thoiGianTao: [
				this.YeuCauXuatKhan.ThoiGianTao
					? this.YeuCauXuatKhan.ThoiGianTao
					: new Date(),
				Validators.required,
			],
			nguoiTao: [
				this.YeuCauXuatKhan.NguoiTao == 0
					? tenNguoiLap
					: this.YeuCauXuatKhan.NguoiTao,
				[Validators.required, Validators.maxLength(50)],
			],
			tinhTrangHangDNXK: [0],
			ketQuaKiemTraChatLuong: [""],
			yKienDeNghi: [""],
		});
		this.YeuCauXuatKhanForm.controls["soPhieu"].disable();
		this.YeuCauXuatKhanForm.controls["nguoiTao"].disable();
		this.YeuCauXuatKhanForm.controls["thoiGianTao"].disable();
		this.YeuCauXuatKhanForm.controls["tinhTrangXuatKhan"].disable();
		if (this.YeuCauXuatKhan.Id > 0) {
			this.listYeuCauXuatKhan_Ct = this.YeuCauXuatKhan.Cts;
			this.tmpYeuCauXuatKhan_Ct = [];
			for (let i = 0; i < this.listYeuCauXuatKhan_Ct.length; i++) {
				let tmpElement = new YeuCauXuatKhan_CtModel();
				tmpElement.copy(this.listYeuCauXuatKhan_Ct[i]);
				this.tmpYeuCauXuatKhan_Ct.push(tmpElement);
			}
			this.tmpYeuCauXuatKhan_Ct = [...this.tmpYeuCauXuatKhan_Ct];
		}
		this.changeDetectView();
	}
	async createBillNumber() {
		var category_path = "YCXK";
		var res = await this.DungChungService.getBillNumber(category_path)
			.toPromise()
			.then((r) => {
				return r;
			});
		if (res && res.status == 1) {
			return res.data;
		} else {
			this.layoutUtilsService.showErorr(
				"Không thể lấy số phiếu tự động."
			);
		}
	}
	deleteItem(i: number) {
		this.tmpYeuCauXuatKhan_Ct.splice(i, 1);
		this.tmpYeuCauXuatKhan_Ct = [...this.tmpYeuCauXuatKhan_Ct];
		this.changeDetectorRefs.detectChanges();
	}
	/**
	 * Returns page title
	 */
	getTitle(): string {
		if (this.data.id) {
			return "CHI TIẾT YÊU CẦU XUẤT KHẨN";
		}
		return "THÊM MỚI YÊU CẦU XUẤT KHẨN";
	}
	/*----------------- Hàm thông báo lỗi cho form tương ứng -----------------*/
	validateInvalidForm() {
		this.hasFormErrors = false;
		const controls = this.YeuCauXuatKhanForm.controls;
		if (this.YeuCauXuatKhanForm.invalid) {
			const invalidElements = this.el.nativeElement.querySelectorAll(
				".ng-invalid"
			);
			if (invalidElements.length > 0) {
				for (let i = 0; i < invalidElements.length; i++) {
					if (
						invalidElements[i].nodeName == "INPUT" ||
						invalidElements[i].nodeName == "MAT-SELECT"
					) {
						const elementControl = this.YeuCauXuatKhanForm.get(
							invalidElements[i].attributes.getNamedItem(
								"formcontrolname"
							).value
						);
						if (elementControl) {
							invalidElements[i].focus();
							break;
						}
					}
				}
			}
			Object.keys(controls).forEach((controlName) =>
				controls[controlName].markAsTouched()
			);
			this.hasFormErrors = true;
			return false;
		}
		return true;
	}
	/* -----------------------------------------------------------------------*/
	/*--------- Các hàm hỗ trợ hiển thị các cột và chuyển cột trong bảng------*/
	showColumnsInTable() {
		for (let i = 0; i < this.availableColumns.length; i++) {
			if (this.availableColumns[i].isShow == false) {
				this.selectedColumns.toggle(this.availableColumns[i]);
			}
		}
	}
	findIndexColumn(column: string) {
		for (let i = 0; i < this.availableColumns.length; i++) {
			if (this.availableColumns[i].name == column) return i;
		}
	}
	dragStarted(event: CdkDragStart, column: string) {
		this.previousIndex = this.findIndexColumn(column);
	}
	dropListDropped(event: CdkDropList, column: string) {
		if (event) {
			moveItemInArray(
				this.availableColumns,
				this.previousIndex,
				this.findIndexColumn(column)
			);
			this.applySelectedColumns();
		}
	}
	applySelectedColumns() {
		let _selectedColumns = this.selectedColumns.selected;
		this.selectedColumns = new SelectionModel<any>(
			true,
			this.availableColumns
		);
		for (let i = 0; i < this.availableColumns.length; i++) {
			this.selectedColumns.toggle(this.availableColumns[i]);
			for (let j = 0; j < _selectedColumns.length; j++) {
				if (this.availableColumns[i].name == _selectedColumns[j].name) {
					this.selectedColumns.toggle(this.availableColumns[i]);
					break;
				}
			}
		}
		const _applySelectedColumns: string[] = [];
		this.selectedColumns.selected.forEach((col) => {
			_applySelectedColumns.push(col.name);
		});
		this.displayedColumns = _applySelectedColumns;
	}
	/* -----------------------------------------------------------------------*/
	/*------------------------- Hàm lấy danh sách-----------------------------*/
	ListHangHoa_id() {
		this.servicePage.listHangHoa_id().subscribe((res) => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listHangHoa_id = res.data;
				this.filteredHangHoa_ids.next(this.listHangHoa_id.slice());
				this.changeDetectorRefs.detectChanges();
			}
		});
	}
	filterHangHoa_id(searchTmp: string = "") {
		if (!this.listHangHoa_id) return;
		// get the search keyword
		let search = this.ListHangHoa_idFilterCtrl;
		if (searchTmp != "" && searchTmp != null) search = "" + searchTmp;
		if (!search) {
			this.filteredHangHoa_ids.next(this.listHangHoa_id.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		if (searchTmp != "") {
			this.filteredHangHoa_ids.next(
				this.listHangHoa_id.filter(
					(ts) => ts.HangHoa_id.toLowerCase().indexOf(search) > -1
				)
			);
		} else {
			this.filteredHangHoa_ids.next(
				this.listHangHoa_id.filter(
					(ts) => ts.HangHoa_id.toLowerCase().indexOf(search) > -1
				)
			);
		}
		this.changeDetectView();
	}
	afterSelectHangHoa_id(value: string) {
		this.listHangHoa_id.forEach((element) => {
			if (element.HangHoa_id == +value) {
				this.selectHangHoa_id = value;
				//this.YeuCauXuatKhan_CtForm.controls["hangHoaId"].setValue(element.HangHoa_id);
				//this.validateInvalidSubForm();
			}
		});
		this.isDisableButton();
	}
	/* -----------------------------------------------------------------------*/
	/*---------------------------- Thao tác trên form ------------------------*/
	isDisableButton() {}
	changeDetectView() {
		if (!(this.changeDetectorRefs as ViewRef).destroyed) {
			this.changeDetectorRefs.detectChanges();
		}
	}
	back(click: boolean = false) {
		if(!click) this.dialogRef.close({data : this.YeuCauXuatKhan});
		else this.dialogRef.close();
	}
	checkThayDoiCanhBao() {
		// Trờ về khi thêm mới
		var warning = false;
		if (
			this.tmpYeuCauXuatKhan_Ct.length !=
			this.tmpYeuCauXuatKhan_CtInit.length
		)
			warning = true;
		if (warning == false)
			warning =
				JSON.stringify(
					this.sortKeyObject(this.YeuCauXuatKhanFormInit)
				) !=
				JSON.stringify(
					this.sortKeyObject(this.YeuCauXuatKhanForm.value)
				);
		if (warning == false) {
			if (
				this.tmpYeuCauXuatKhan_Ct.length ==
					this.YeuCauXuatKhan.Cts.length &&
				this.YeuCauXuatKhan.Cts.length > 0
			) {
				this.tmpYeuCauXuatKhan_Ct.forEach((x) => {
					if (
						this.YeuCauXuatKhan.Cts.findIndex(
							(a) =>
								a.Id == x.Id &&
								a.HangHoaId == x.HangHoaId &&
								a.IdLo == x.IdLo &&
								a.NgaySX == x.NgaySX &&
								a.NgayDeNghiPassKhan == x.NgayDeNghiPassKhan &&
								a.KhoiLuong == x.KhoiLuong
						) == -1
					) {
						warning = true;
					}
				});
			}
		}
		return warning;
	}

	prepareDate() {
		const controls = this.YeuCauXuatKhanForm.controls;
		let m = {};
		m["bo_phan_yeu_cau"] = Number(controls['boPhanYeuCau'].value);
		m["so_phieu"] = controls['soPhieu'].value;
		m["ngay_de_nghi"] = moment(new Date(controls["ngayDeNghi"].value)).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
		m["nguoi_de_nghi"] = Number(controls['nguoiDeNghi'].value);
		m["ly_do_pass_khan"] = Number(controls['tinhTrangHangDNXK'].value);
		m["ghi_chu_ly_do"] = controls['ghiChuTinhTrang'].value;
		m["id"] = this.YeuCauXuatKhan.Id ? this.YeuCauXuatKhan.Id : 0;
		m["details"] = [];
		let rows = [...this.tmpYeuCauXuatKhan_Ct];
		let main = rows.find(_x => _x.IsMain);
		if(main != null){
			// Loại BTP
			if(main.IsBTP || main.IsThanhPham){
				let row = rows.filter(_x => !_x.IsMain && _x.ma_may && _x.IsChecked);
				row.forEach(_r => {
					let d = {};
					d["hang_hoa_id"] = _r["HangHoaId"];
					d["id_lo"] = _r["IdLo"];
					d["ngay_de_nghi_pass_khan"] = _r["NgayDeNghiPassKhan"];
					d["ngay_sx"] = _r["NgaySX"];
					d["khoi_luong"] = Number(_r['SoLuongCanXuat']);
					d["kho_dnxk_ct_id"] = _r["DeNghiXuatKho_Id"] ? Number(_r["DeNghiXuatKho_Id"]) : 0;
					d["ton_kho_hien_tai_id"] = Number(_r["IdTk"]);
					let rowLOT = rows.find(_x => !_x.IsMain && !_x.ma_may && _x.Id == _r.Id);
					if(rowLOT != null){
						d["nguyen_nhan_pass"] = rowLOT["NguyenNhanXK"] ? rowLOT["NguyenNhanXK"] : "";
						d["ghi_chu_nguyen_nhan"] = rowLOT["GhiChuNguyenNhan"] ? rowLOT["GhiChuNguyenNhan"] : "";
					}
					let ma_may = _r["ma_may"];
					var bo_chi_tieu = _r["machines"].find(_x => _x.ma_may == ma_may);
					d["qa_pass_hang_tong_hop_id"] = bo_chi_tieu != null ? Number(bo_chi_tieu["qa_pass_tong_hop"]) : 0;
					d["so_luong_can_xuat"] = _r["khoi_luong"] ? Number(_r["khoi_luong"]) : 0;
					m["details"].push(d);
				});
			}
			// Loại NPL, BB
			if(main.IsAnother){
				let row = rows.filter(_x => !_x.IsMain && _x.IsChecked);
				row.forEach(_r => {
					let d = {};
					d["hang_hoa_id"] = _r["HangHoaId"];
					d["id_lo"] = _r["IdLo"];
					d["ngay_de_nghi_pass_khan"] = _r["NgayDeNghiPassKhan"];
					d["ngay_sx"] = _r["NgaySX"];
					d["khoi_luong"] = Number(_r['SoLuongCanXuat']);
					d["kho_dnxk_ct_id"] = _r["DeNghiXuatKho_Id"] ? Number(_r["DeNghiXuatKho_Id"]) : null;
					d["ton_kho_hien_tai_id"] = Number(_r["IdTk"]);
					d["nguyen_nhan_pass"] = _r["NguyenNhanXK"] ? _r["NguyenNhanXK"] : "";
					d["ghi_chu_nguyen_nhan"] = _r["GhiChuNguyenNhan"] ? _r["GhiChuNguyenNhan"] : "";
					d["qa_pass_hang_tong_hop_id"] = null;
					d["so_luong_can_xuat"] = _r["KhoiLuong"] ? Number(_r["KhoiLuong"]) : 0;
					m["details"].push(d);
				})
			}
		}
		console.log(m);
		return m;
	}
	
	onSubmit(type: number) {
		this.hasFormErrors = false;
		if (!this.validateInvalidForm())
			return null;
		let rowLOT = this.tmpYeuCauXuatKhan_Ct.filter(_x => !_x.IsMain && !_x.ma_may && !_x.chi_tieu && _x['IsChecked']);
		if (rowLOT.length == 0) {
			this.layoutUtilsService.showErorr("Vui lòng chọn số lô cần xuất khẩn cho hàng hóa");
			return false;
		}else{
			// Nếu là loại hh BTP thì kiểm tra đã chọn máy chưa
			if(rowLOT[0].IsBTP || rowLOT[0].IsThanhPham){
				let fails = [];
				rowLOT.forEach(_lot => {
					let num_r = this.tmpYeuCauXuatKhan_Ct.filter(_x => !_x.IsMain && _x.ma_may && _x.IdLo == _lot.IdLo && _x['IsChecked']);
					if(num_r.length == 0) fails.push(_lot.LotSX);
				});
				if(fails.length > 0){
					let mess = "Vui lòng chọn dữ liệu thùng cho LOT: "+fails.join(", ");
					this.layoutUtilsService.showErorr(mess);
					return false;
				}
			}
		}
		if (rowLOT.filter(x => !x.NguyenNhanXK).length > 0) {
			this.layoutUtilsService.showErorr("Vui lòng chọn nguyên nhân xuất khẩn");
			return false;
		}
		/* prepare */
		const controls = this.YeuCauXuatKhanForm.controls;
		let data = this.prepareDate();
		data["tinh_trang_ma"] = (type == 1 || type == 2) ? SettingYCXK.pk_status[1].value : SettingYCXK.pk_status[0].value;
		data["id"] = this.YeuCauXuatKhan.Id ? this.YeuCauXuatKhan.Id : 0;
		console.log(data);
		if (type == 1 || type == 2) {
			const dialogRef = this.layoutUtilsService.POP02(data["so_phieu"]);
			dialogRef.afterClosed().subscribe(res => {
				if (!res) {
					return;
				}
				this.optionCallService(data, type);
			});
		} else {
			this.optionCallService(data, type);
		}
	}
	
	optionCallService(data: any, type: number){
		if (this.YeuCauXuatKhan.Id > 0) {
			this.updateYeuCauXuatKhan(data, type)
			return;
		}
		this.addYeuCauXuatKhan(data, type);
	}

	updateYeuCauXuatKhan(item: any, withBack: number) {
		item.Id = this.YeuCauXuatKhan.Id;
		this.servicePage.updateYeuCauXuatKhan(item).subscribe(res => {
			if (res.status == 1) {
				const message = `Cập nhật yêu cầu xuất khẩn ` + res.data.SoPhieu + ` thành công`;
				this.layoutUtilsService.showInfo(message);
				let index = this.saveAddedDNMH.findIndex(x => x == res.data.Id);
				if (index == -1)
					this.saveAddedDNMH.push(res.data.Id);
				this.isChange = true;
				this.YeuCauXuatKhan = res.data;
				// Luu nháp
				if (withBack == 0) {
					this.router.navigateByUrl('/yeu-cau-xuat-khan/chinh-sua/' + res.data.Id);
					this.changeDetectorRefs.detectChanges();
					return;
				}
				this.checkGuiDuyet(false);
				// Lưu và thêm mới
				if (withBack == 2) {
					this.YeuCauXuatKhanForm.reset();
					this.YeuCauXuatKhanForm.controls['LoaiXuatKhan'].setValue('0');
					this.YeuCauXuatKhanForm.controls['khachHangId'].setValue('0');
					this.YeuCauXuatKhanForm.controls['khuVucId'].value;
					this.YeuCauXuatKhanForm.controls['tinhTrangXuatKhan'].setValue('0');
					this.YeuCauXuatKhanForm.controls['ghiChuTinhTrang'].value;
					this.YeuCauXuatKhanForm.controls['ngayDeNghi'].setValue(new Date());
					this.YeuCauXuatKhanForm.controls['nguoiDeNghi'].value;
					this.YeuCauXuatKhanForm.controls['thoiGianTao'].setValue(new Date());
					this.YeuCauXuatKhanForm.controls['nguoiTao'].value;
					this.tmpYeuCauXuatKhan_Ct = [];
					this.listYeuCauXuatKhan_Ct = [];
					this.tmpYeuCauXuatKhan_Ct = [...this.tmpYeuCauXuatKhan_Ct];
					this.router.navigateByUrl('/yeu-cau-xuat-khan/them-moi');
					this.changeDetectorRefs.detectChanges();
					return;
				}
				// Lưu và trờ lại
				if (withBack == 1) {
					this.YeuCauXuatKhanForm.reset();
					this.tmpYeuCauXuatKhan_Ct = [];
					this.tmpYeuCauXuatKhan_Ct = [...this.tmpYeuCauXuatKhan_Ct];
					this.back();
				}
				this.isChange = true;
				this.back();
			} else {
				this.layoutUtilsService.showErorr(res.error.message);
			}
		});
	}

	checkGuiDuyet(checked: boolean = false) {
		if (checked) {
			this.YeuCauXuatKhanForm.controls['tinhTrangXuatKhan'].setValue(this.optionsTrangThai[1].name);
		} else {
			this.YeuCauXuatKhanForm.controls['tinhTrangXuatKhan'].setValue(this.optionsTrangThai[0].name);
		}
	}

	addYeuCauXuatKhan(item: any, withBack: number) {
		this.servicePage.insert_pk_btp(item).subscribe(res => {
			if (res.status == 1) {
				const message = `Thêm mới yêu cầu xuất khẩn ` + res.data.SoPhieu + ` thành công`;
				this.layoutUtilsService.showInfo(message);
				let index = this.saveAddedDNMH.findIndex(x => x == res.data.Id);
				if (index == -1)
					this.saveAddedDNMH.push(res.data.Id);
				this.isChange = true;
				this.YeuCauXuatKhan = res.data;
				// Luu nháp
				if (withBack == 0) {
					this.router.navigateByUrl('/yeu-cau-xuat-khan/chinh-sua/' + res.data.Id);
					this.changeDetectorRefs.detectChanges();
					return;
				}
				this.checkGuiDuyet(false);
				// Lưu và thêm mới
				if (withBack == 2) {
					this.YeuCauXuatKhanForm.reset();
					this.YeuCauXuatKhanForm.controls['LoaiXuatKhan'].setValue('0');
					this.YeuCauXuatKhanForm.controls['khachHangId'].setValue('0');
					this.YeuCauXuatKhanForm.controls['khuVucId'].value;
					this.YeuCauXuatKhanForm.controls['tinhTrangXuatKhan'].setValue('0');
					this.YeuCauXuatKhanForm.controls['ghiChuTinhTrang'].value;
					this.YeuCauXuatKhanForm.controls['ngayDeNghi'].setValue(new Date());
					this.YeuCauXuatKhanForm.controls['nguoiDeNghi'].value;
					this.YeuCauXuatKhanForm.controls['thoiGianTao'].setValue(new Date());
					this.YeuCauXuatKhanForm.controls['nguoiTao'].value;
					this.tmpYeuCauXuatKhan_Ct = [];
					this.listYeuCauXuatKhan_Ct = [];
					this.tmpYeuCauXuatKhan_Ct = [...this.tmpYeuCauXuatKhan_Ct];
					this.router.navigateByUrl('/yeu-cau-xuat-khan/them-moi');
					this.changeDetectorRefs.detectChanges();
					return;
				}
				// Lưu và trờ lại
				if (withBack == 1) {
					this.YeuCauXuatKhanForm.reset();
					this.tmpYeuCauXuatKhan_Ct = [];
					this.tmpYeuCauXuatKhan_Ct = [...this.tmpYeuCauXuatKhan_Ct];
					this.back();
				}
				this.isChange = true;
				this.back();
			} else {
				this.layoutUtilsService.showErorr(res.error.message);
			}
		});
	}
	/* -----------------------------------------------------------------------*/
	/*--------- Các hàm hỗ trợ cho thay đổi - cập nhập dữ liệu trên bảng------*/
	ValidateChangeNumberEvent(event: any, columnName: string, item: any) {
		var count = 0;
		for (let i = 0; i < event.target.value.length; i++) {
			if (event.target.value[i] == ".") {
				count += 1;
			}
		}
		var regex = this.CONFIG.REGEX_SPECIAL_CHARACTER;
		var found = event.target.value.match(regex);
		if (found != null) {
			const message = "Dữ liệu không gồm chữ hoặc kí tự đặc biệt";
			this.layoutUtilsService.showErorr(message);
			return false;
		}
		if (count >= 2) {
			const message = "Dữ liệu không thể có nhiều hơn 2 dấu .";
			this.layoutUtilsService.showErorr(message);
			return false;
		}
		return true;
	}
	changeValueOfForm(controlName: string, event: any, type: number) {
		// if( type == 1){
		// 	if(this.ValidateChangeNumberForm(event)){
		// 		let tmpValue = this.YeuCauXuatKhanForm.controls[controlName].value.replace(/,/g, "");
		// 		this.YeuCauXuatKhanForm.controls[controlName].setValue(
		// 				this.f_currency_V2(tmpValue)
		// 		);
		// 	}
		// 	else{
		// 		this.YeuCauXuatKhanForm.controls[controlName].setValue(event.target.value);
		// 	}
		// }
		// else if(type == 2){
		// 	if(this.ValidateChangeNumberForm(event)){
		// 		let tmpValue = this.YeuCauXuatKhan_CtForm.controls[controlName].value.replace(/,/g, "");
		// 		this.YeuCauXuatKhan_CtForm.controls[controlName].setValue(
		// 				this.f_currency(this.formatNumber(tmpValue))
		// 		);
		// 	}
		// 	else{
		// 		this.YeuCauXuatKhan_CtForm.controls[controlName].setValue(event.target.value);
		// 	}
		// 	this.isDisableButton();
		// }
	}
	/* -----------------------------------------------------------------------*/
	/*------------------ Hàm hỗ trợ format các dạng số trên form -------------*/
	ValidateChangeNumberForm(event: any, isEvent: boolean = true) {
		var count = 0;
		if (isEvent) {
			for (let i = 0; i < event.target.value.length; i++) {
				if (event.target.value[i] == ",") {
					count += 1;
				}
			}
		} else {
			event = "" + event;
			for (let i = 0; i < event.length; i++) {
				if (event[i] == ",") {
					count += 1;
				}
			}
		}
		var regex = this.CONFIG.REGEX_SPECIAL_CHARACTER;
		var found = isEvent
			? event.target.value.match(regex)
			: event.match(regex);
		if (found != null) {
			return false;
		}
		if (count >= 2) {
			return false;
		}
		return true;
	}
	formatNumber(item: string) {
		if (item == "" || item == null || item == undefined) return "";
		return Number(
			Math.round(parseFloat(item + "e" + this.fixedPoint)) +
				"e-" +
				this.fixedPoint
		).toFixed(this.fixedPoint);
	}
	f_currency(value: string): any {
		if (value == null || value == undefined || value == "") value = "0.00";
		let nbr = Number(
			(
				value.substring(0, value.length - (this.fixedPoint + 1)) + ""
			).replace(/,/g, "")
		);
		return (
			(nbr + "").replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") +
			value.substr(
				value.length - (this.fixedPoint + 1),
				this.fixedPoint + 1
			)
		);
	}
	f_currency_V2(value: string): any {
		if (value == "-1") return "";
		if (value == null || value == undefined || value == "") value = "0";
		let nbr = Number((value + "").replace(/,/g, ""));
		return (nbr + "").replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	}
	f_currency_VND(value: string): any {
		if (value == null || value == undefined) return "0,00";
		return new Intl.NumberFormat("de-DE", {
			style: "decimal",
			currency: "VND",
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		}).format(Number(value));
	}
	formatComparenumber(number: string) {
		return +number.replace(/\./g, "").replace(/,/g, ".");
	}
	/* -----------------------------------------------------------------------*/
	/*----------------- Hàm hỗ trợ format các dạng ngày trên form ------------*/
	f_convertDateTime(date: string) {
		var componentsDateTime = date.split("/");
		var date = componentsDateTime[0];
		var month = componentsDateTime[1];
		var year = componentsDateTime[2];
		var formatConvert =
			year + "-" + month + "-" + date + "T00:00:00.0000000";
		return new Date(formatConvert);
	}
	f_convertDate(p_Val: any) {
		let a = p_Val === "" ? new Date() : new Date(p_Val);
		return (
			a.getFullYear() +
			"/" +
			("0" + (a.getMonth() + 1)).slice(-2) +
			"/" +
			("0" + a.getDate()).slice(-2)
		);
	}
	/* -----------------------------------------------------------------------*/
	openChange($event: boolean) {
		if ($event) {
			this.cdkVirtualScrollViewPort.scrollToIndex(0);
			this.cdkVirtualScrollViewPort.checkViewportSize();
		} else {
		}
	}
	/*------------------------------- Focus form -----------------------------*/
	focusWhenEscapseDropDown(nameDropDown: string) {
		this.changeDetectView();
	}
	forcusAnotherEmptyField(control: any) {
		Object.keys(control).forEach((controlName) => {
			if (
				control[controlName].value == null ||
				control[controlName].value == undefined ||
				control[controlName].value == ""
			) {
			}
			this.changeDetectView();
		});
	}
	focusEvents() {
		if (this.focus != null && this.focus != undefined) {
			setTimeout(() => this.focus.first.nativeElement.focus(), 500);
			this.changeDetectView();
		}
	}
	/* -----------------------------------------------------------------------*/
	ListNhomHH() {
		this.DungChungService.listLoaiHH().subscribe((res) => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listNhomHang = res.data;
				this.filteredNhomHang.next(this.listNhomHang.slice());
				this.changeDetectView();
			}
		});
	}
	filterNhomHH() {
		if (!this.listNhomHang) {
			return;
		}
		let search = this.NhomHangFilterCtrl;
		if (!search) {
			this.filteredNhomHang.next(this.listNhomHang.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredNhomHang.next(
			this.listNhomHang.filter(
				(ts) => ts.TenLoaiHH.toLowerCase().indexOf(search) > -1
			)
		);
		this.changeDetectView();
	}
	ListBP(select: boolean = false) {
		const res = this.DungChungService.listPhongBanAll().subscribe((res) => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.viewLoading = false;
				this.listListBP = res.data;
				this.filteredListBP.next(this.listListBP.slice());
				this.changeDetectorRefs.detectChanges();
			}
		});
	}
	filterListBP() {
		if (!this.listListBP) {
			return;
		}
		// get the search keyword
		let search = this.ListBPFilterCtrl;
		if (!search) {
			this.filteredListBP.next(this.listListBP.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredListBP.next(
			this.listListBP.filter(
				(ts) => ("Do " + ts.TenPB).toLowerCase().indexOf(search) > -1
			)
		);
		this.changeDetectorRefs.detectChanges();
	}
	GetDSNhanVien(event: any) {
		var value = event.value ? event.value : event;
		this.listIdNV = [];
		this.filteredIdNV.next([]);
		this.YeuCauXuatKhanForm.controls["nguoiDeNghi"].setValue("");
		this.DungChungService.listNVPB(+value).subscribe((res) => {
			if (res && res.status == 1) {
				this.listIdNV = res.data;
				this.filteredIdNV.next(this.listIdNV.slice());
				this.changeDetectorRefs.detectChanges();
			}
		});
	}
	filterNhanVien() {
		if (!this.listIdNV) {
			return;
		}
		let search = this.IdNVFilterCtrl;
		if (!search) {
			this.filteredIdNV.next(this.listIdNV.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredIdNV.next(
			this.listIdNV.filter(
				(ts) => ts.TenNV.toLowerCase().indexOf(search) > -1
			)
		);
		this.changeDetectorRefs.detectChanges();
	}
	ListId_HH() {
		this.listId_HH = [];
		this.filteredId_HH.next(this.listId_HH.slice());
		this.spinnerLoadHH = true;
		this.DungChungService.layDanhSachHangHoaInit().subscribe((res) => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listId_HH = res.data;
				this.sumRecord = this.listId_HH.length;
				this.filteredId_HH.next(this.listId_HH.slice());
				this.spinnerLoadHH = false;
				//this.YeuCauXuatKhan_CtForm.controls['hangHoaId'].enable();
				this.changeDetectorRefs.detectChanges();
			} else {
				this.spinnerLoadHH = false;
				//this.YeuCauXuatKhan_CtForm.controls['hangHoaId'].enable();
			}
		});
	}
	filterId_HH(searchTmp: string = "") {
		let tmpListHH = [];
		tmpListHH = this.listId_HH;
		if (!tmpListHH) {
			return;
		}
		// get the search keyword
		let search = this.Id_HHFilterCtrl;
		if (searchTmp != "") search = "" + searchTmp;
		if (!search) {
			this.sumRecord = tmpListHH.length;
			this.filteredId_HH.next(tmpListHH.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		if (searchTmp != "") {
			this.sumRecord = tmpListHH.filter(
				(ts) =>
					(ts.MaHH + " - " + ts.TenHH).toLowerCase().indexOf(search) >
					-1
			).length;
			this.filteredId_HH.next(
				tmpListHH.filter(
					(ts) =>
						(ts.MaHH + " - " + ts.TenHH)
							.toLowerCase()
							.indexOf(search) > -1
				)
			);
		} else {
			this.sumRecord = tmpListHH.filter(
				(ts) => ts.MaHang.toLowerCase().indexOf(search) > -1
			).length;
			this.filteredId_HH.next(
				tmpListHH.filter(
					(ts) => ts.MaHang.toLowerCase().indexOf(search) > -1
				)
			);
		}
		this.changeDetectorRefs.detectChanges();
	}
	afterSelectHH(value: string) {
		//let controls = this.YeuCauXuatKhan_CtForm.controls;
		this.listId_HH.forEach((element) => {
			if (element.IdHH == +value) {
				this.selectId_HH = value;
				//this.YeuCauXuatKhan_CtForm.controls['hangHoaId'].setValue(element.TenHH);
				//this.YeuCauXuatKhan_CtForm.controls['hangHoaId'].disable();
				this.ListLotSX(+value);
				this.changeDetectorRefs.detectChanges();
			}
		});
	}
	ListLotSX(IdHH: number) {
		this.listLotSX = [];
		this.filteredLotSX.next(this.listLotSX.slice());
		if (isNumber(IdHH) && IdHH > 0) {
			this.spinnerLoadLot = true;
			//this.YeuCauXuatKhan_CtForm.controls['lotSX'].setValue('');
			this.DungChungService.layDanhSachLotKhongXuatKhoInit(
				+this.selectId_HH
			).subscribe((res) => {
				this.loadingSubject.next(false);
				if (res && res.status === 1) {
					this.listLotSX = res.data ? res.data : [];
					this.sumRecordLotSX = this.listLotSX.length;
					this.filteredLotSX.next(this.listLotSX.slice());
					this.spinnerLoadLot = false;
					this.changeDetectorRefs.detectChanges();
				} else {
					this.spinnerLoadLot = false;
				}
			});
		}
	}
	filterLotSX(searchTmp: string = "") {
		let tmpListLotSX = [];
		tmpListLotSX = this.listLotSX;
		if (!tmpListLotSX) {
			return;
		}
		// get the search keyword
		let search = this.LotSXFilterCtrl;
		if (searchTmp != "") search = "" + searchTmp;
		if (!search) {
			this.sumRecordLotSX = tmpListLotSX.length;
			this.filteredLotSX.next(tmpListLotSX.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		if (searchTmp != "") {
			this.sumRecordLotSX = tmpListLotSX.filter(
				(ts) => ts.Ma_Lot.toLowerCase().indexOf(search) > -1
			).length;
			this.filteredLotSX.next(
				tmpListLotSX.filter(
					(ts) => ts.Ma_Lot.toLowerCase().indexOf(search) > -1
				)
			);
		} else {
			this.sumRecordLotSX = tmpListLotSX.filter(
				(ts) => ts.Ma_Lot.toLowerCase().indexOf(search) > -1
			).length;
			this.filteredLotSX.next(
				tmpListLotSX.filter(
					(ts) => ts.Ma_Lot.toLowerCase().indexOf(search) > -1
				)
			);
		}
		this.changeDetectorRefs.detectChanges();
	}
	keyUpInputNumberVND(event) {
		FunctionPublic.preventAlphaV2(event);
	}
	changeInputOfFormVND(
		controlName: string,
		event: any,
		min: number = 0,
		formGroup
	) {
		let controls = formGroup.controls;
		if (controls[controlName].value == "") {
			controls[controlName].setValue(this.f_number(0));
		}
		let tmpValue = controls[controlName].value
			.replace(/\./g, "")
			.replace(/,/g, ".");
		if (isNaN(tmpValue)) tmpValue = 0.0;
		if (Number(tmpValue) < min) tmpValue = min;
		if (!controls[controlName].invalid) {
			controls[controlName].setValue(this.f_number(tmpValue));
		}
		if (tmpValue.toString().indexOf(",") == 0 && tmpValue.length == 1) {
			tmpValue = min;
		}
		controls[controlName].setValue(this.f_number(tmpValue));
	}
	f_number(item: any = "0.00") {
		return FunctionPublic.F_NUMBER(item);
	}
	getFormatDate(v: string = "") {
		if (v != "") {
			return v.includes("T")
				? v.replace(
						/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g,
						"$5/$3/$1"
				  )
				: v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
		}
		return "";
	}
	changeInputOfFormVNDInList(
		columnName: string,
		event: any,
		min: number = 0,
		item: YeuCauXuatKhan_CtModel,
		max: number = 0
	) {
		if (event.target.value == "") {
			event.target.value = this.f_number(min);
			event.target.selectionStart = 0;
			event.target.selectionEnd = 0;
		}
		if (event.target.value.toString() == item[columnName].toString()) {
			event.target.value = this.f_number(item[columnName]);
			event.target.selectionStart = 0;
			event.target.selectionEnd = 0;
		}
		if (this.ValidateChangeNumberForm(event)) {
			let tmpValue = event.target.value
				.replace(/\./g, "")
				.replace(/,/g, ".");
			if (isNaN(tmpValue)) tmpValue = min;
			if (Number(tmpValue) < min) tmpValue = min;
			if (Number(tmpValue) > max) tmpValue = max;
			if (!item[columnName]) {
				item[columnName] = tmpValue;
			}
			item[columnName] = tmpValue;
			event.target.value = this.f_number(tmpValue);
		} else {
			item[columnName] = min;
		}
		this.reloadTotalMassChecked(item.HangHoaId);
		this.changeDetectorRefs.detectChanges();
	}
	showTPDuyet() {
		return (
			(this.url_current == "duyet" &&
				(this.YeuCauXuatKhan.TinhTrang_Code ==
					this.optionsTrangThai[1].value ||
					this.YeuCauXuatKhan.TinhTrang_Code ==
						this.optionsTrangThai[2].value ||
					this.YeuCauXuatKhan.TinhTrang_Code ==
						this.optionsTrangThai[3].value)) ||
			this.url_current == "chi-tiet"
		);
	}
	showQCDuyet() {
		return (
			(this.url_current == "duyet" &&
				(this.YeuCauXuatKhan.TinhTrang_Code ==
					this.optionsTrangThai[2].value ||
					this.YeuCauXuatKhan.TinhTrang_Code ==
						this.optionsTrangThai[3].value)) ||
			this.url_current == "chi-tiet"
		);
	}
	showTPQCDuyet() {
		return (
			(this.url_current == "duyet" &&
				this.YeuCauXuatKhan.TinhTrang_Code ==
					this.optionsTrangThai[3].value) ||
			this.url_current == "chi-tiet"
		);
	}
	changeKetQuaDuyet(event: any, level: number) {
		if (event.value == "YCXK_KHONGDUYET_CONFIRM") {
			if (level == 1) {
				this.YeuCauXuatKhanForm.controls["TP_LYDO"].setValidators([
					Validators.required,
				]);
				this.YeuCauXuatKhanForm.controls[
					"TP_LYDO"
				].updateValueAndValidity();
			}
			if (level == 2) {
				this.YeuCauXuatKhanForm.controls["QC_LYDO"].setValidators([
					Validators.required,
				]);
				this.YeuCauXuatKhanForm.controls[
					"QC_LYDO"
				].updateValueAndValidity();
			}
			if (level == 3) {
				this.YeuCauXuatKhanForm.controls["TPQC_LYDO"].setValidators([
					Validators.required,
				]);
				this.YeuCauXuatKhanForm.controls[
					"TPQC_LYDO"
				].updateValueAndValidity();
			}
		} else {
			if (level == 1) {
				this.YeuCauXuatKhanForm.controls["TP_LYDO"].clearValidators();
				this.YeuCauXuatKhanForm.controls[
					"TP_LYDO"
				].updateValueAndValidity();
			}
			if (level == 2) {
				this.YeuCauXuatKhanForm.controls["QC_LYDO"].clearValidators();
				this.YeuCauXuatKhanForm.controls[
					"QC_LYDO"
				].updateValueAndValidity();
			}
			if (level == 3) {
				this.YeuCauXuatKhanForm.controls["TPQC_LYDO"].clearValidators();
				this.YeuCauXuatKhanForm.controls[
					"TPQC_LYDO"
				].updateValueAndValidity();
			}
		}
		Object.keys(this.YeuCauXuatKhanForm.controls).forEach((controlName) =>
			this.YeuCauXuatKhanForm.controls[controlName].markAsTouched()
		);
		this.changeDetectorRefs.detectChanges();
	}
	LuuKQDuyet(level: number = 1) {
		var firstChar = "TP";
		switch (level) {
			case 1:
				firstChar = "TP";
				break;
			case 2:
				firstChar = "QC";
				break;
			case 3:
				firstChar = "TPQC";
				break;
		}
		var data = {
			DeNghiPassKhanId: this.YeuCauXuatKhan.Id,
			LoaiThaoTac: this.YeuCauXuatKhanForm.controls[
				firstChar + "_KETQUADUYET"
			].value,
			NoiDung: this.YeuCauXuatKhanForm.controls[firstChar + "_LYDO"].value
				? this.YeuCauXuatKhanForm.controls[firstChar + "_LYDO"].value
				: "",
			KetQuaKiemTraChatLuong:
				level == 2
					? this.YeuCauXuatKhanForm.controls["ketQuaKiemTraChatLuong"]
							.value
					: "",
			YKienDeNghi:
				level == 2
					? this.YeuCauXuatKhanForm.controls["yKienDeNghi"].value
					: "",
		};
		if (
			data.LoaiThaoTac == "YCXK_KHONGDUYET_CONFIRM" &&
			(data.NoiDung == null || data.NoiDung.toString().trim().length == 0)
		) {
			this.layoutUtilsService.showErorr(
				"Bạn chưa nhập lý do không duyệt"
			);
			return false;
		}
		if (
			data.LoaiThaoTac == "YCXK_DUYET_CONFIRM" ||
			(data.LoaiThaoTac == "YCXK_KHONGDUYET_CONFIRM" &&
				data.NoiDung != null &&
				data.NoiDung.toString().trim().length > 0)
		) {
			const dialogRef = this.layoutUtilsService.POP02(
				this.YeuCauXuatKhan.SoPhieu
			);
			dialogRef.afterClosed().subscribe((res) => {
				if (!res) {
					return;
				}
				this.servicePage.accept(data).subscribe((res) => {
					if (res && res.status == 1) {
						this.layoutUtilsService.showInfo(
							"Phiếu yêu cầu xuất khẩn " +
								this.YeuCauXuatKhan.SoPhieu +
								" đã được duyệt thành công"
						);
						this.back();
					} else {
						this.layoutUtilsService.showErorr(res.error.message);
					}
				});
			});
		}
	}
	sortKeyObject(unordered: object) {
		const ordered = {};
		Object.keys(unordered)
			.sort()
			.forEach(function (key) {
				ordered[key] = unordered[key];
			});
		return ordered;
	}
	showInfoMaSP() {
		return this.spinnerLoadHH ? "Đang tải ..." : "[Chọn mã sản phẩm]";
	}
	calcSLChecked(item: any) {
		var sumChecked = this.tmpYeuCauXuatKhan_Ct
			.filter(
				(x) =>
					!x["IsMain"] &&
					x.HangHoaId == item.HangHoaId &&
					x["IsChecked"]
			)
			.map((x) => Number(x["KhoiLuong"]));
		var i = this.tmpYeuCauXuatKhan_Ct.findIndex(
			(x) => x.HangHoaId == item.HangHoaId && x["IsMain"]
		);
		if (i > -1) {
			this.tmpYeuCauXuatKhan_Ct[i]["TongTonDaChon"] =
				sumChecked.length == 0 ? 0 : sumChecked.reduce((a, b) => a + b);
			this.tmpYeuCauXuatKhan_Ct = [...this.tmpYeuCauXuatKhan_Ct];
		}
	}
	PushRowMainInList(data: YeuCauXuatKhan_CtModel[]) {
		let arrHangHoaId = [...new Set(data.map((x) => x.HangHoaId))];
		arrHangHoaId.forEach((h) => {
			var row = data.filter((x) => x.HangHoaId == h)[0];
			var main = new YeuCauXuatKhan_CtModel();
			main.IsMain = true;
			main.STT = arrHangHoaId.indexOf(h) + 1;
			main.HangHoaId = row.HangHoaId;
			main.HangHoaMa = row.HangHoaMa;
			main.HangHoaTen = row.HangHoaTen;
			main.SoLuongCanXuat = row.SoLuongCanXuat;
			main.TongTonDaChon = this.tmpYeuCauXuatKhan_Ct
				.filter(
					(x) => !x["IsMain"] && x.HangHoaId == h && x["IsChecked"]
				)
				.map((x) => x["KhoiLuong"])
				.reduce((a, b) => a + b);
			this.tmpYeuCauXuatKhan_Ct.splice(
				this.tmpYeuCauXuatKhan_Ct.findIndex((x) => x.HangHoaId == h),
				0,
				main
			);
		});
	}
	OpenDialogKTHH(item: YeuCauXuatKhan_CtModel) {
		this.opendialog = true;
		var dataBinding = new HangNhapKho();
		dataBinding.clear();
		dataBinding.IdLoaiHH = item.IdLoaiHH;
		dataBinding.IdHh = item.HangHoaId;
		console.log(dataBinding);
		const dialogRef = this.dialog.open(PhieuKiemTraPassKhanComponent, {
			data: {
				data: dataBinding,
				Id: item.IdPKT,
			},
			maxHeight: "90vh",
			width: "90vw",
		});
		dialogRef.afterClosed().subscribe((res) => {
			if (res && res.isChange) {
				item.IdPKTPK = res.data.IdPKTPK;
				item.ChoPhepXuatKho = res.data.ChoPhepXuatKho;
				this.tmpYeuCauXuatKhan_Ct = [...this.tmpYeuCauXuatKhan_Ct];
				if (res.masterChange) this.back();
			}
			setTimeout(() => {
				this.opendialog = false;
			}, 100);
			this.changeDetectView();
		});
	}
	async FindMauKiemTra(IdHH: number) {
		var res = await this.servicePKT
			.getInfoMauKiemTra(IdHH)
			.toPromise()
			.then((r) => {
				return r;
			});
		if (res && res.status == 1) return true;
		else {
			this.layoutUtilsService.showErorr(
				"Không tồn tại mẫu kiểm tra để lập phiếu!"
			);
			return false;
		}
	}
	findKetQuaKiemTra(item: any) {
		return item.ChoPhepXuatKho == null
			? ""
			: item.ChoPhepXuatKho
			? "Được xuất kho"
			: "Không được xuất kho";
	}
	changeTinhTrangHangDeNghiXuatKhan(event: any) {
		if (event.value == 0) {
			this.YeuCauXuatKhanForm.controls[
				"ghiChuTinhTrang"
			].clearValidators();
			this.YeuCauXuatKhanForm.controls[
				"ghiChuTinhTrang"
			].updateValueAndValidity();
		} else {
			this.YeuCauXuatKhanForm.controls["ghiChuTinhTrang"].setValidators(
				Validators.required
			);
			this.YeuCauXuatKhanForm.controls[
				"ghiChuTinhTrang"
			].updateValueAndValidity();
		}
		this.changeDetectorRefs.detectChanges();
	}
	overInventory(item: any) {
		return (
			Number(item.KhoiLuong) > Number(item.KhoiLuongTon) ||
			Number(item.KhoiLuong) <= 0
		);
	}
	reloadTotalMassChecked(idhh: number) {
		// Find Row Master
		var r = this.tmpYeuCauXuatKhan_Ct.findIndex(
			(x) => x.HangHoaId == idhh && x.IsMain
		);
		if (r < 0) return;
		this.tmpYeuCauXuatKhan_Ct[r].TongTonDaChon = this.tmpYeuCauXuatKhan_Ct
			.filter(
				(x) =>
					!x["IsMain"] &&
					x.HangHoaId == this.tmpYeuCauXuatKhan_Ct[r].HangHoaId &&
					x["IsChecked"]
			)
			.map((x) => Number(x["KhoiLuong"]))
			.reduce((a, b) => a + b);
		this.tmpYeuCauXuatKhan_Ct = [...this.tmpYeuCauXuatKhan_Ct];
		this.changeDetectView();
	}

	getDNXKs(){
		var rObjs = [];
		this.tmpYeuCauXuatKhan_Ct.forEach(_x => {
			if(rObjs.findIndex(_r => _r.IdDNXK == _x.DeNghiXuatKho_Id) == -1){
				var rObj = {};
				rObj["IdDNXK"] = _x.DeNghiXuatKho_Id;
				rObj["SoPhieu"] = _x.DeNghiXuatKho_SoPhieu;
				rObjs.push(rObj);
			}
		})
		return rObjs;
	}

	open_dialog_detail_dnxk(__iddn: number) {
		this.dkService.detail(__iddn).subscribe((res) => {
			if (res.status == 1) {
				const dialogRef = this.dialog.open(
					KhoDeNghiXuatKhoDialogDetailComponent,
					{
						data: {
							data: res.data,
							canEdit: false,
						},
						maxHeight: "90vh",
						width: "90vw",
					}
				);
			} else {
				this.layoutUtilsService.showErorr(res.error.message);
			}
		});
	}
	disabledMachine(item) {
		return this.tmpYeuCauXuatKhan_Ct.filter(x => !x['IsMain']
			&& !x['ma_may']
			&& !x["chi_tieu"]
			&& x.HangHoaId == item.HangHoaId
			&& item.Id == x.Id
			&& x.IdLo == item.IdLo
			&& x['IsChecked']
		).length == 0;
	}

	changedLOTs(item) {
		var arrMachines = this.tmpYeuCauXuatKhan_Ct.filter(x => !x['IsMain']
			&& x['ma_may']
			&& x.HangHoaId == item.HangHoaId
			&& item.Id == x.Id
			&& item.IdLo == x.IdLo
			&& x['IsChecked']);

		arrMachines.forEach(obj => obj.IsChecked = false);
		this.tmpYeuCauXuatKhan_Ct = [...this.tmpYeuCauXuatKhan_Ct];
		this.changeDetectView();
	}

	getMerOfType(){
		this.merOption = {};
		this.filteredId_HH.next(this.listId_HH.slice());
		this.spinnerLoadHH = true;
		this.servicePage.get_mers_of_type(this.typeOfMer).subscribe(res => {
			if (res && res.status === 1) {
				this.listId_HH = res.data;
				this.sumRecord = res.data.length;
				this.spinnerLoadHH = false;
				this.filteredId_HH.next(this.listId_HH.slice());
				this.changeDetectorRefs.detectChanges();
			} else {
				this.spinnerLoadHH = false;
			}
		});
	}

	changeWeightMer(event: any, min: number = 0) {
		if (event.target.value == "") {
			event.target.value = this.f_number(min);
			event.target.selectionStart = 0;
			event.target.selectionEnd = 0;
		}
		if (this.ValidateChangeNumberForm(event)) {
			let tmpValue = event.target.value.replace(/\./g, "").replace(/,/g, ".");
			if (isNaN(tmpValue)) tmpValue = min;
			if (Number(tmpValue) < min) tmpValue = min;
			if (!this.weightMer) {
				this.weightMer = tmpValue;
			}
			this.weightMer = tmpValue;
			event.target.value = this.f_number(tmpValue);
		} else {
			this.weightMer = min;
		}
		this.changeDetectorRefs.detectChanges();
	}

	getOptionText(option) {
		this.merOption = option;
		return option != null ? option.MaHH : "";
	}

	clearSelectHH(event: any){
		this.selectedOption = {};
		this.merOption = {};
		this.sumRecord = this.listId_HH.length;
		this.filteredId_HH.next(this.listId_HH.slice());
	}

	isObjNull(obj: any){
		return JSON.stringify(obj).replace('{', '').replace('}', '').trim().length == 0;
	}

	addManualMerIntoList(){
		this.addMer.next(true);
		let data = [
			{
				IdDn : 0,
				IdCtDn : 0,
				IdHH : this.merOption['Id_HH'],
				KeHoachId : 0,
				SLCanXuat : this.weightMer
			}
		];
		
		this.servicePage.FindDataLotDNXK(data).subscribe(res => {
			this.addMer.next(false);
			if (res && res.status == 1) {
				if(res.data.length == 1){
					this.layoutUtilsService.showErorr("Không tìm thấy dữ liệu tồn kho cho xuất khẩn");
					return;
				}
				res.data.forEach((d, index) => {
					var data = {...d}; 
					data.KhoiLuong = Number(d.KhoiLuong);
					data.KhoiLuongTon = Number(d.KhoiLuong);
					this.tmpYeuCauXuatKhan_Ct.push(data);
					if (!data.IsMain) {
						d.machines.forEach(machine => {
							var data2 = {...d}; 
							data2.ma_may = machine.ma_may;
							data2.khoi_luong = machine.khoi_luong;
							this.tmpYeuCauXuatKhan_Ct.push(data2);
							var data3 = {...d}; 
							if (machine.chi_tieu.length > 0) {
								data3.chi_tieu = machine.chi_tieu
								this.tmpYeuCauXuatKhan_Ct.push(data3);
							}
						});
					}
				});
				this.tmpYeuCauXuatKhan_Ct = [...this.tmpYeuCauXuatKhan_Ct];
				this.changeDetectorRefs.detectChanges();
				this.merOption = {};
				this.weightMer = 0;
				this.typeOfMer = this.listTypeOfMers[0].value;
				console.log(this.tmpYeuCauXuatKhan_Ct);
			} else {
				this.layoutUtilsService.showErorr("Không thể lấy được danh sách yêu cầu pass khẩn");
			}
		});
	}

	sumMachineSelectedOfLOT(id_lo: number){
		let m_selected = this.tmpYeuCauXuatKhan_Ct.filter(_x => _x.IdLo == id_lo && !_x['IsMain'] && _x['ma_may'] && _x['IsChecked']);
		if(m_selected.length == 0) return 0;
		return m_selected.map(_x => Number(_x.khoi_luong)).reduce((a, b) => a + b);
	}

	sumWeightAll(){
		let m_selected = this.tmpYeuCauXuatKhan_Ct.filter(_x => !_x['IsMain'] && _x['ma_may']);
		if(m_selected.length == 0) return 0;
		return m_selected.map(_x => Number(_x.khoi_luong)).reduce((a, b) => a + b);
	}

	sumWeightAllSelected(){
		if(!this.tmpYeuCauXuatKhan_Ct || this.tmpYeuCauXuatKhan_Ct.length == 0) return 0;
		let _btp = this.tmpYeuCauXuatKhan_Ct[0].IsBTP;
		let _tp = this.tmpYeuCauXuatKhan_Ct[0].IsThanhPham;
		let _diff = this.tmpYeuCauXuatKhan_Ct[0].IsAnother;
		let m_selected = [];
		if(_btp || _tp){
			m_selected = this.tmpYeuCauXuatKhan_Ct.filter(_x => !_x['IsMain'] && _x['ma_may'] && _x['IsChecked']);
			if(m_selected.length == 0) return 0;
			return m_selected.map(_x => Number(_x.khoi_luong)).reduce((a, b) => a + b);	
		}
		if(_diff){
			m_selected = this.tmpYeuCauXuatKhan_Ct.filter(_x => !_x['IsMain'] && _x['IsChecked']);		
			if(m_selected.length == 0) return 0;
			return m_selected.map(_x => Number(_x.KhoiLuong)).reduce((a, b) => a + b);
		}
		
	}

	sumMachineOfLOT(id_lo: number){
		let m_selected = this.tmpYeuCauXuatKhan_Ct.filter(_x => _x.IdLo == id_lo && !_x['IsMain'] && _x['ma_may']);
		if(m_selected.length == 0) return 0;
		return m_selected.map(_x => Number(_x.khoi_luong)).reduce((a, b) => a + b);
	}
	
	clearAllMer(){
		this.tmpYeuCauXuatKhan_Ct = []; this.selectedOption = {};
		this.filterId_HH();
	}
}
